<template>
    <!--烟感报警-->
    <div class="smokeAlarm">
        <el-row :gutter="32">
            <el-col :span="3">
                <el-steps direction="vertical" :active="active" style="height:calc(50vh);">
                    <el-step title="接警"></el-step>
                    <el-step title="调度派单"></el-step> 
                    <el-step title="火场文书"></el-step>
                </el-steps>
            </el-col>
            <el-col :span="21">
                <div v-if="active === 1">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>报警信息</span>
                         </div>
                        <div class="cardTitle">
                            <div class="cardTitleItem">{{alarmInfo.alarmSingle.alarmTime}}</div>
                            <div class="cardTitleItem">{{alarmInfo.equipmentDO.address}}</div>
                           <!-- <div class="cardTitleItem">{{alarmInfo.smokeEquipmentDO.equipmnetName}} | {{alarmInfo.smokeEquipmentDO.phone}} <div class="cardTitleItemBtn"><el-button size="small" @click="callPhone(alarmInfo.smokeEquipmentDO.phone)" type="primary">立即呼叫</el-button></div></div>
                            <div class="cardTitleItem" v-if="alarmInfo.smokeEquipmentDO.equipmnetNametwo != null">{{alarmInfo.smokeEquipmentDO.equipmnetNametwo}} | {{alarmInfo.smokeEquipmentDO.phonetwo}}<div class="cardTitleItemBtn"> <el-button size="small" @click="callPhone(alarmInfo.smokeEquipmentDO.phonetwo)" type="primary">立即呼叫</el-button></div></div>
                            <div class="cardTitleItem">{{alarmInfo.smokeEquipmentDO.urgencyName}} | {{alarmInfo.smokeEquipmentDO.urgencyPhone}}<div class="cardTitleItemBtn"> <el-button size="small" @click="callPhone(alarmInfo.smokeEquipmentDO.urgencyPhone)" type="primary">立即呼叫</el-button></div></div> -->

                        </div>
                    </el-card>
                    <div class="bottomBtn">
                        <el-row :gutter="32">

                            <el-col :span="10" :offset="1">
                                <el-button style="background-color:rgba(0, 103, 176, 1)">关闭</el-button>
                            </el-col>
                            <el-col :span="10" :offset="1">
                                <el-button style="background-color:rgba(202, 44, 104, 1)" @click="dispatchOrder">出警派单</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
                <div v-if="active === 2">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>报警信息</span>
                        </div>
                        <div class="cardTitle">
                            <el-row :gutter="32">
                                <el-col :span="12">
                                     <div class="cardTitleItem">{{alarmInfo.alarmSingle.alarmTime}}</div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="cardTitleItem">{{alarmInfo.equipmentDO.address}}</div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>选择出警队员</span>
                        </div>
                        <div class="cardTitle">
                            <el-checkbox-group v-model="selectCjPersons">
                                <el-row :gutter="32">
                                    <el-col :span="4" v-for="(item,index) in cjPersons" :key="index" >
                                        <el-checkbox :label="item" :key="item.id">{{item.name}}</el-checkbox>
                                    </el-col>
                                </el-row>
                            </el-checkbox-group>
                        </div>
                    </el-card>
                    <el-card class="box-card">
                        <div slot="header" class="clearfix" v-if="selectEquip">
                            <span>请选择出警装备及数量</span>
                        </div>
                        <div class="cardTitle" v-if="selectEquip">
                            <el-checkbox-group v-model="selectEqus">
                                <el-row :gutter="32">
                                    <el-col :span="6" v-for="(item,index) in equs" :key="index">
                                        <el-checkbox :label="item" :key="item.id">{{item.ename}}</el-checkbox>
                                        <el-input-number v-model="item.num" :step="1" size="small" :min="0" style="margin-left:5px;"></el-input-number>
                                    </el-col>
                                </el-row>
                            </el-checkbox-group>
                        </div>
                        <div class="bottomBtn">
                            <el-row :gutter="32">
                                <el-col :span="18" :offset="3">
                                    <el-button type="primary" @click="police">出警</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </el-card>

                </div>
                <div v-if="active === 3">
                    <fireBook ref="fireBook" :selectRow="selectRow" @closeSmokeAlarm="closeSmokeAlarm"></fireBook>
                </div>
                <el-dialog title="" :visible.sync="dialogVisible" width="30%" append-to-body center show-close>
                    <!-- <el-image :src="require('@/assets/img/close.png')"></el-image> -->
                    <div class="tip">
                        请根据实际情况输入处警异常结束的原因
                    </div>
                    <div>
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="falseContent"></el-input>
                    </div>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submitFalseContent">提 交</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import fireBook from '@/pages/fireBook/fireBook'
export default {
    components:{
        fireBook
    },
    props:['alarmId'],
    data(){
        return{
            active: this.$store.state.smokeAlarmActive,
            selectRow: {id:this.alarmId},
            dialogVisible: false,
            falseContent: '',
            alarmInfo: {},
            selectCjPersons:[],
            selectEqus: [],
            equs: [],
            cjPersons: [],
            selectEquip: true
        }
    },
    created(){
        let _this = this;
        if(!_this.active){
            _this.active = 1;
            _this.selectEquip = true;
        }
        if(_this.active === 2){
            _this.handleSearch();
            _this.selectEquip = false;
        }
        _this.queryFireBook();
        _this.queryEquipInfo();
    },
    methods:{
        closeSmokeAlarm(){
            let _this = this;
            _this.$emit("closeSmokeAlarm");
        },
        handleSearch(){
            let _this = this;
            var success = function(resp){
                _this.cjPersons = resp.userDOList;
                resp.equipment.forEach(function(item){
                    item.num = 0;
                    _this.equs.push(item);
                });
            }
            _this.http.get('/webapi/writ/isMisdeclaration/'+ _this.alarmId,{},success);
        },

        queryEquipInfo(){
            let _this = this;
            let success = function(resp){
                _this.alarmInfo = resp;
            }
            _this.http.get('/webapi/probe/findProbe/'+_this.alarmId,{},success);
        },

        dispatchOrder(){
            let _this = this;
            _this.handleSearch();
            _this.$store.commit('updateSmokeAlarmActive',_this.active++);
        },
        police(){
            let _this = this;
            _this.dispatchOrder2();
        },
        dispatchOrder2(){
            let _this = this;
            if(_this.selectEquip && _this.selectCjPersons.length <= 0){
                _this.$message.warning("请选择出警人员")
                return;
            }
            if(_this.selectEquip && _this.selectEqus.length <= 0){
                _this.$message.warning("请选择装备")
                return;
            }
            _this.selectEqus.forEach(function(item){
                if(item.num === 0){
                    _this.$message.warning("已选装备数量不能为0");
                    return ;
                }
            })
            var alarmCommanderIds = _this.selectCjPersons.map(item =>{
                return item.id;
            });
            var equipmentIds = _this.selectEqus.map(item =>{
                return item.id;
            });
            var equipmentNumbers = _this.selectEqus.map(item =>{
                return item.num;
            });
            var data = {
                id:_this.alarmId,
                alarmCommanderIds:alarmCommanderIds.join(),
                equipmentIds: equipmentIds.join(),
                equipmentNumbers: equipmentNumbers.join()
            }
            var success = function(resp){
                if(resp.code === '0'){
                    _this.$store.commit('updateSmokeAlarmActive',_this.active++);
                    _this.$store.commit('updateSelectFireBookActive','first');
                }
            }
            _this.http.post('/webapi/writ/goPoliceAdd',data,success);
        },
        queryFireBook(){//查询火场文书
            let _this = this;
            var success = function(resp){
                _this.selectRow.queryFireBook = resp;
                _this.selectRow.audit = '1';
                _this.selectRow.idStr = _this.idStr;
            }
            _this.http.get('/webapi/alarmSmoke/'+_this.alarmId,{},success);
        }
    }
}
</script>
<style lang="less">
.smokeAlarm{
    height:100%;
    .el-row{
        .el-col{
            .el-steps{
                margin-left: 40px;
            }
            .el-card{
                margin: 0 50px;
                .el-card__header{
                    text-align: center;
                    background-color: rgba(29, 69, 138, 1);
                    color: white;
                }
                .cardTitle{
                    padding-top: 10px;
                    .cardTitleItem{
                        padding: 10px;
                        .cardTitleItemBtn{
                            float: right;
                            margin-right: 50%;
                        }
                    }
                }
            }
            .bottomBtn{
                margin: 10px 50px 0px 50px;
                .el-row{
                    .el-col{
                        height: 70px !important;
                        .el-button{
                            width: 100%;
                            height: 70% !important;
                            padding: 5px 0 5px 20px;
                            height: 100%;
                            font-size: 18px;
                            font-weight: 700;
                            font-weight: 700;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
    }
}
.tip{
    font-size: 18px;
    line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/alarm/monitorAlarm.vue